import React from 'react'
import type { PublicProfile } from 'apollo-gql'

import { Card } from 'components/UI/Card/Card'
import useResponsive from 'hooks/useResponsive'

import MarqueeCards from './MarqueeCards'

import styles from './BusinessPageHero.module.css'

type BusinessPageHeroProps = {
  profiles: PublicProfile[]
}

const ROW_BREAKPOINT = 10

const BusinessPageHero = ({ profiles }: BusinessPageHeroProps): JSX.Element => {
  const { isDesktop } = useResponsive()

  const profileCards = profiles
    .filter((profile) => profile.hasB2bProduct)
    .map((profile) => (
      <div key={profile.id} className={styles.card}>
        <Card
          talentName={profile.name}
          talentDescription={profile.title}
          imageUrl={profile.profilePicture?.cardUrl}
          size="small"
          type="featured"
          priority
        />
      </div>
    ))

  const firstRow = profileCards.slice(0, ROW_BREAKPOINT)
  const secondRow = profileCards.slice(ROW_BREAKPOINT)

  if (firstRow.length < ROW_BREAKPOINT) {
    return (
      <div data-cy="businessPageHero" className={styles.fewCardsWrapper}>
        {firstRow}
      </div>
    )
  }

  return (
    <div className={styles.wrapper} data-cy="businessPageHero">
      <MarqueeCards elements={firstRow} />

      {isDesktop && (
        <div className={styles.secondRow}>
          <MarqueeCards elements={secondRow} slower />
        </div>
      )}
    </div>
  )
}

export default BusinessPageHero
